import { captureEvent } from './captureEvent'
import type {
  ActionCompletedProps,
  ActionFailedProps,
  ActionSignedProps,
  ActionSubmittedProps,
  BridgeCompletedProps,
  BridgeFailedProps,
  BridgeFormViewedProps,
  BridgeSignedProps,
  BridgeSubmittedProps,
  LendBorrowAmountEnteredProps,
  LendBorrowAssetSelectedProps,
  LendBorrowPageViewedProps,
  ModalClosedProps,
  ModalOpenedProps,
  MultiplyCompletedProps,
  MultiplyFailedProps,
  MultiplySignedProps,
  MultiplySubmittedProps,
  SwapApprovalCompletedProps,
  SwapApprovalRequestedProps,
  SwapCompletedProps,
  SwapFailedProps,
  SwapFormViewedProps,
  SwapQuoteFailedProps,
  SwapQuoteReceivedProps,
  SwapSignedProps,
  SwapSubmittedProps,
  WalletConnectClickedProps,
  WalletConnectCompletedProps,
  WalletConnectFailedProps,
} from './types'

export interface AnalyticsEventMap {
  // Wallet
  wallet_connect_clicked: WalletConnectClickedProps
  wallet_connect_completed: WalletConnectCompletedProps
  wallet_connect_failed: WalletConnectFailedProps
  // Swap
  swap_form_viewed: SwapFormViewedProps
  swap_quote_received: SwapQuoteReceivedProps
  swap_quote_failed: SwapQuoteFailedProps
  swap_submitted: SwapSubmittedProps
  swap_approval_requested: SwapApprovalRequestedProps
  swap_approval_completed: SwapApprovalCompletedProps
  swap_signed: SwapSignedProps
  swap_completed: SwapCompletedProps
  swap_failed: SwapFailedProps
  // Bridge
  bridge_form_viewed: BridgeFormViewedProps
  bridge_submitted: BridgeSubmittedProps
  bridge_signed: BridgeSignedProps
  bridge_completed: BridgeCompletedProps
  bridge_failed: BridgeFailedProps
  // Lend/Borrow
  lend_borrow_page_viewed: LendBorrowPageViewedProps
  lend_borrow_asset_selected: LendBorrowAssetSelectedProps
  lend_borrow_amount_entered: LendBorrowAmountEnteredProps
  // Multiply
  multiply_submitted: MultiplySubmittedProps
  multiply_signed: MultiplySignedProps
  multiply_completed: MultiplyCompletedProps
  multiply_failed: MultiplyFailedProps
  // Modal
  modal_opened: ModalOpenedProps
  modal_closed: ModalClosedProps
}

interface ActionStageMap {
  submitted: ActionSubmittedProps
  signed: ActionSignedProps
  completed: ActionCompletedProps
  failed: ActionFailedProps
}

interface MultiplyStageMap {
  submitted: MultiplySubmittedProps
  signed: MultiplySignedProps
  completed: MultiplyCompletedProps
  failed: MultiplyFailedProps
}

export function track<K extends keyof AnalyticsEventMap>(event: K, props: AnalyticsEventMap[K]): void {
  captureEvent(event, props)
}

export function trackAction<S extends keyof ActionStageMap>(stage: S, props: ActionStageMap[S]): void {
  captureEvent(`${props.action_type}_${stage}`, props)
}

export function trackMultiply<S extends keyof MultiplyStageMap>(stage: S, props: MultiplyStageMap[S]): void {
  captureEvent(`multiply_${stage}`, props)
}
